module.exports = __webpack_public_path__ + "static/media/icon_quanlydiadanh2.000a3dd4.svg";